import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-turns-reports-average-card',
  templateUrl: './turns-reports-average-card.component.html',
  styleUrls: ['./turns-reports-average-card.component.scss']
})
export class TurnsReportsAverageCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
